module.exports = __webpack_public_path__ + "img/3-1.1a57caa0.jpg";